"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResult = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const searchField_module_scss_1 = __importDefault(require("./searchField.module.scss"));
const useOnClickOutside_1 = __importDefault(require("../../hooks/useOnClickOutside"));
const useKeyPress_1 = __importDefault(require("../../hooks/useKeyPress"));
const InputField_1 = __importDefault(require("../InputField"));
const icons_1 = require("../../icons");
const Stack_1 = __importDefault(require("../Stack"));
const SearchField = (_a, ref) => {
    var { children, value, showResults, withSearchIcon = true, iconButtonAfter, fullWidth = false, onClose = () => null } = _a, inputProps = __rest(_a, ["children", "value", "showResults", "withSearchIcon", "iconButtonAfter", "fullWidth", "onClose"]);
    const containerRef = (0, react_1.useRef)(null);
    const shouldRenderResults = showResults && react_1.default.Children.toArray(children).length > 0;
    (0, useOnClickOutside_1.default)(containerRef, onClose);
    const escape = (0, useKeyPress_1.default)('Escape');
    (0, react_1.useEffect)(() => {
        if (escape) {
            onClose();
        }
    }, [escape]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(searchField_module_scss_1.default.container, fullWidth && searchField_module_scss_1.default.fullWidth), ref: containerRef, children: [(0, jsx_runtime_1.jsxs)("div", { className: searchField_module_scss_1.default.wrapper, "aria-expanded": shouldRenderResults, "aria-owns": "search-field-listbox", "aria-haspopup": "listbox", children: [withSearchIcon && ((0, jsx_runtime_1.jsx)("span", { className: searchField_module_scss_1.default.icon, children: (0, jsx_runtime_1.jsx)(icons_1.SearchIcon, {}) })), (0, jsx_runtime_1.jsx)(InputField_1.default, Object.assign({}, inputProps, { value: value, "aria-autocomplete": "list", "aria-controls": "search-field-listbox", className: searchField_module_scss_1.default.input, ref: ref })), !!iconButtonAfter && (0, jsx_runtime_1.jsx)("span", { children: iconButtonAfter })] }), shouldRenderResults && ((0, jsx_runtime_1.jsx)("ul", { className: searchField_module_scss_1.default.results, role: "listbox", children: children }))] }));
};
exports.default = (0, react_1.forwardRef)(SearchField);
const SearchResult = (_a) => {
    var { iconBefore, children } = _a, props = __rest(_a, ["iconBefore", "children"]);
    return ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: searchField_module_scss_1.default.result }, props, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, { layout: "horizontal", align: "center", children: [iconBefore && (0, jsx_runtime_1.jsx)("span", { className: searchField_module_scss_1.default.resultIcon, children: iconBefore }), children] }) })));
};
exports.SearchResult = SearchResult;
